
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Clock } from 'lucide-react';
import { Load } from '../types';
import { getLoadIcon } from '../utils/loadIcons';

interface ZoneCardProps {
  zoneName: string;
  zoneId: string;
  load: Load | null;
  isSelected: boolean;
  onSelect: (zoneId: string) => void;
  onToggleStatus: (id: string) => void;
  onSchedule: (load: Load) => void;
}

const ZoneCard: React.FC<ZoneCardProps> = ({
  zoneName,
  zoneId,
  load,
  isSelected,
  onSelect,
  onToggleStatus,
  onSchedule
}) => {
  return (
    <Card 
      className={`border ${isSelected ? 'border-blue-500 dark:border-blue-400' : 'border-gray-200 dark:border-gray-700'} 
        cursor-pointer hover:border-blue-400 dark:hover:border-blue-500 transition-colors`}
      onClick={() => onSelect(zoneId)}
    >
      <CardContent className="p-4">
        <div className="flex justify-between items-start mb-2">
          <h3 className="font-medium">{zoneName}</h3>
          {load && (
            <Switch 
              checked={load.status} 
              onCheckedChange={() => onToggleStatus(load.id)} 
            />
          )}
        </div>
        
        {load ? (
          <div className="space-y-2">
            <div className="flex items-center text-sm">
              {getLoadIcon(load.type)}
              <span className="ml-2 font-medium">{load.name}</span>
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              <span>Power: {load.powerRating}</span>
              <span className="mx-2">•</span>
              <span>Current: {load.status ? load.currentConsumption : '0W'}</span>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                onSchedule(load);
              }}
              className="text-xs h-8 mt-2 bg-white dark:bg-transparent border-gray-300 dark:border-gray-700 text-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800"
            >
              <Clock className="mr-1 h-3 w-3" />
              {load.schedules.length > 0 ? `${load.schedules.length} Schedule(s)` : 'Add Schedule'}
            </Button>
          </div>
        ) : (
          <div className="flex items-center justify-center h-16 text-sm text-gray-500 dark:text-gray-400">
            No load assigned to this zone
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ZoneCard;
